// extracted by mini-css-extract-plugin
module.exports = {"badge":"omf_badge__h7Vzn"};